import React, { useState, useEffect } from 'react'
import classnames from 'classnames'
import { Input } from 'antd'

import Icon from '../Icon'
import './index.less'
import { useTranslation } from 'react-i18next'

const Search = ({ className, placeholder = '', onSearch, values = '', ...props }) => {
  const [value, setValue] = useState(values || '')
  const { t } = useTranslation()
  const onClick = () => {
    onSearch && onSearch(value)
  }
  useEffect(() => {
    if (!values) {
      setValue('')
    }
  }, [values])
  return (
    <div {...props} className={classnames('cust-search', className)}>
      <Input
        value={value}
        bordered={false}
        onPressEnter={onClick}
        onChange={(e) => {
          setValue(e.target.value)
        }}
        placeholder={placeholder || t('common.search')}
        suffix={<Icon onClick={onClick} type="icon-search" className="search-icon" />}
      />
      {/* <input placeholder= type="search" ref={searchRef} />
       */}
    </div>
  )
}

export default Search
